import React from 'react';

import Button from 'react-bootstrap/Button';


/**
 * CHECKED-2021
 */
const ButtonAndSpinner = (props) => {

    let style = props.style ? props.style : {};

    let disabled = (props.disabled)?{disabled:true}:"";

    let size = props.size?props.size:"27px";

    let styleInner = {
        width:size,
        height:size,
        minWidth:size,
        minHeight:size,
        color:"#492728",
    };

    let label1 = props.label1?props.label1:"Submit";
    let label2 = props.label2?props.label2:"Submitting...";


    return (

        <Button className={"btn btn-primary "+(props.className?props.className:"")} onClick={props.onClick} style={{...style,position:"relative"}} {...disabled} >
            <div className={"w-100 d-flex justify-content-center align-items-center"}>
            {!props.submitInProgress?label1:label2}

            </div>
            {
                (!props.submitInProgress) ?
                    (
                        ""// <img className={"inline-block ml-2"} src={require("../../../assets/images/icons/ico-btn-arrow.svg").default} alt=""/>
                    ) :
                    (
                        <div style={{position:"absolute", top:0, left:0, right:0, bottom:0, display:"flex", justifyContent:"flex-end", alignItems:"center", paddingRight:"10px"}}>
                            <span className="ml-2 spinner-border spinner-border-sm"
                                  role="status"
                                  aria-hidden="true"
                                  style={styleInner}/>
                        </div>
                    )
            }
        </Button>
    );
};


export default ButtonAndSpinner;
